import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-yoodli-reg-confirmation',
  templateUrl: './yoodli-reg-confirmation.component.html',
  standalone: false,
  styleUrl: './yoodli-reg-confirmation.component.scss'
})
export class YoodliRegConfirmationComponent {

  constructor(
    public dialogRef: MatDialogRef<YoodliRegConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
